// ============================================================
// Generic fallback pack
// app/components/skyplus/shared/sector/packs/generic.pack.ts
// ============================================================

import { Pack } from '../sector.model';

export const GENERIC_PACK: Pack = {
  packId:      'generic',
  packName:    'Generic',
  packVersion: '1.0.0',
  accentColor: '#5F5E5A',

  vocabulary: {
    'caseFile.singular':     'Case file',
    'caseFile.plural':       'Case files',
    'caseFile.new':          'New case file',
    'participant.singular':  'Participant',
    'participant.plural':    'Participants',
    'participant.id':        'ID number',
    'paymentPack':           'Payment pack',
    'masterRecord':          'Master record',
    'masterRecord.id':       'Record number',
    'masterRecord.singular': 'Record',
    'masterRecord.plural':   'Records',
    'dashboard.title':       'Dashboard',
    'ai.placeholder':        'Ask about your content...',
    'upload.target':         'documents'
  },

  caseFileTypes: [
    {
      key:            'generic',
      label:          'Case file',
      aspects:        ['sp:caseFile'],
      classification: 'INTERNAL',
      workflow:       null,
      checklist:      []
    }
  ],

  integrations: [],

  aiPrompts: {
    systemContext:    'You are a helpful assistant for a document management system. Answer using only documents the user has access to. Always cite sources.',
    suggestedQueries: [
      'What documents were added this week?',
      'Find files assigned to me',
      'Show documents pending approval'
    ],
    entityHints: ['reference number', 'date', 'amount']
  },

  compliance: {
    regulators:     [],
    retentionRules: [],
    piiFields:      ['nationalId', 'email', 'phone']
  },

  dashboards: [
    { key: 'default', route: '/dashboard', title: 'Dashboard' }
  ]
};
